export default __webpack_public_path__ + "static/media/react-icon.62c6dc49.png";